<section class="page">
  <div class="page-content">
    @if (isLoading() || userId() === null || patientId() === 0) {
      <app-progress-spinner></app-progress-spinner>
    } @else {
      <div class="confirmation-shell">
        <h3 class="confirmation-title">Confirmation</h3>
        <div class="confirmation-banner">
          <app-icon name="check_circle" size="md" color="green"></app-icon>
          <p>{{ confirmationMessages[confirmationType] }}</p>
        </div>
        <app-notification-preferences-form
          [notificationType]="filteredNotificationTypes()"
          [notificationPreferences]="notificationPreferences()"
          [showSaveButton]="showSave !== undefined ? showSave : true"
          [isSaving]="isSaving()"
          [errorMessage]="saveError()"
          (saveNotificationPreferencesEvent)="updateNotificationPreferences($event)"
          (cancelNotificationPreferencesEvent)="
            cancelNotificationPreferences(isMobileBrowser())
          "></app-notification-preferences-form>
      </div>
    }
  </div>
</section>
